"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
function Landmark(props) {
    const { title, subtitle, isSelected, onClick } = props;
    return ((0, jsx_runtime_1.jsx)(Container, { onClick: onClick, children: (0, jsx_runtime_1.jsxs)(TextContainer, { "$isSelected": isSelected, children: [(0, jsx_runtime_1.jsx)(Title, { children: title }), (0, jsx_runtime_1.jsx)(Subtitle, { children: subtitle })] }) }));
}
const Title = styled_components_1.default.div `
  font-weight: 700;
`;
const Subtitle = styled_components_1.default.div `
  margin-top: 4px;
  font-weight: 400;
`;
const TextContainer = styled_components_1.default.div `
  font-size: 16px;

  padding-left: 0;

  color: ${({ theme, $isSelected }) => $isSelected
    ? theme.grasshopper.text.white
    : theme.grasshopper.text.whiteSecondary};
`;
const Container = styled_components_1.default.div `
  padding: 8px;

  display: flex;
  align-items: center;

  cursor: pointer;
`;
exports.default = Landmark;
